export default __webpack_public_path__ + "ff93068a7b2f4c6a134922916ad78e14.jpeg";